// extracted by mini-css-extract-plugin
export const globalWrapper = "layout-module--globalWrapper--jeeli";
export const contentWrapper = "layout-module--contentWrapper--2ew03";